<template>
  <div class="cn-footer-menu-mobile">
    <div
      v-for="(item, i) in menu"
      :key="item.id"
      class="cn-footer-menu-mobile__item"
      :class="{ 'cn-footer-menu-mobile__item--active': i === activeItem }"
    >
      <button
        class="cn-footer-menu-mobile__item-title"
        @click="setActiveItem(i)"
      >
        <span>{{ item.name }}</span>
        <UiIcon
          v-if="item.children && item.children.length"
          name="chevron-down"
        />
      </button>
      <ul
        v-if="i === activeItem && item.children && item.children.length"
        class="cn-footer-menu-mobile__item-list"
      >
        <li v-for="child in item.children" :key="child.id">
          <UiLink :to="child.url" class="cn-footer-menu-mobile__item-link">
            {{ child.name }}
          </UiLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAccordion } from '@/composables';
import UiLink from '@/components/ui/UiLink';
import UiIcon from '@/components/ui/UiIcon';

interface Props {
  menu: any[];
}

defineProps<Props>();

const { activeItem, setActiveItem } = useAccordion();
</script>

<style lang="scss">
.cn-footer-menu-mobile {
  --ab-canyon-footer-menu-mobile-item-title-color-text: var(
    --ab-canyon-color-dark
  );
  --ab-canyon-footer-menu-mobile-item-link-color-text: var(
    --ab-canyon-color-neutral-dark
  );
  row-gap: var(--size-base);
  flex-wrap: wrap;
  display: flex;
  &__item {
    width: 100%;
    &--active {
      .cn-footer-menu-mobile {
        &__item-title {
          .cn-icon {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  &__item-title {
    color: var(--ab-canyon-footer-menu-mobile-item-title-color-text);

    font-weight: 700;
    text-align: left;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    display: flex;
    @media (min-width: 656px) {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }
    .cn-icon {
      transition-property: transform;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration: 150ms;

      width: var(--size-lg);
      height: var(--size-lg);
    }
  }
  &__item-list {
    margin-top: var(--size-base);
    > :not([hidden]) {
      ~ :not([hidden]) {
        margin-top: var(--size-base);
      }
    }
  }
  &__item-link {
    color: var(--ab-canyon-footer-menu-mobile-item-link-color-text);
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
